function SectionBadge({ children, delay = 0, className = "" }) {
  return (
    <span
      className={`
        inline-flex
        items-center
        bg-white
        text-[#D40C1A]
        text-[12px]
        font-semibold
        leading-none
        px-3.5
        py-1.5
        rounded-full
        shadow-[0_2px_8px_rgba(120,32,24,0.08)]
        origin-bottom
        animate-badge-tilt
        ${className}
      `}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </span>
  );
}

export default SectionBadge;
